import router from '@/router'
import { useAuthStore } from '@/stores/auth'

const BASE = '/api/v1'

// Mirrors the shape axios throws so all existing catch blocks work unchanged:
// e.response?.status, e.response?.data?.detail
class ApiError extends Error {
  constructor(status, data) {
    super(`HTTP ${status}`)
    this.response = { status, data }
  }
}

async function request(method, path, { params, body } = {}) {
  let url = BASE + path
  if (params) {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v != null)
    ).toString()
    if (qs) url += '?' + qs
  }

  const init = { method, credentials: 'include' }
  if (body !== undefined) {
    init.headers = { 'Content-Type': 'application/json' }
    init.body = JSON.stringify(body)
  }

  const res = await fetch(url, init)

  let data = null
  if (res.status !== 204 && (res.headers.get('content-type') || '').includes('application/json')) {
    data = await res.json()
  }

  if (!res.ok) {
    // On a 401 from a business endpoint, re-verify with the server before touching
    // the store. The session may have expired; only redirect if /auth/me also fails.
    if (res.status === 401 && !path.startsWith('/auth/')) {
      const auth = useAuthStore()
      if (auth.isLoggedIn) {
        auth.fetchMe().then(() => {
          if (!auth.isLoggedIn) {
            const fullPath = router.currentRoute.value.fullPath
            router.push({ path: '/login', query: fullPath !== '/' ? { redirect: fullPath } : {} })
          }
        })
      }
    }
    throw new ApiError(res.status, data)
  }

  return { data }
}

const client = {
  get: (path, options = {}) => request('GET', path, options),
  post: (path, body, options = {}) => request('POST', path, { ...options, body }),
  put: (path, body, options = {}) => request('PUT', path, { ...options, body }),
  delete: (path, options = {}) => request('DELETE', path, options),
}

export default client
